import { RootState, useAppDispatch, useAppSelector } from "../../../store";
import { useEffect, useRef, useState } from "react";

import { User } from "../../../model/model";
import { lessonActions } from "../../../store/slices/lessonSlice";

export const useLoaUser = () => {
  const userData = useAppSelector((state: RootState) => state.user.user);
  const [loaUser, setUser] = useState<User>();
  const previousLocation = useRef<{ course: string; lesson: number }>();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (userData) {
      const location = {
        course: userData.course.key,
        lesson: userData.current,
      };
      const locationChanged =
        !previousLocation.current ||
        previousLocation.current.course !== location.course ||
        previousLocation.current.lesson !== location.lesson;

      // User updates also arrive when an audio or material is completed. Those
      // updates must not replace a lesson the learner selected for review.
      if (locationChanged) {
        dispatch(
          lessonActions.setLesson(userData.course.lessons[userData.current])
        );
      }
      dispatch(lessonActions.setCourse(userData.course));
      previousLocation.current = location;
      setUser(userData);
    }
  }, [userData, dispatch]);

  return { loaUser };
};
